import { render, staticRenderFns } from "./HmFilterShop.vue?vue&type=template&id=48fa9afe&scoped=true&"
import script from "./HmFilterShop.vue?vue&type=script&lang=js&"
export * from "./HmFilterShop.vue?vue&type=script&lang=js&"
import style0 from "./HmFilterShop.vue?vue&type=style&index=0&id=48fa9afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa9afe",
  null
  
)

component.options.__file = "HmFilterShop.vue"
export default component.exports